import React, { useState } from 'react';

import usePublicApi from 'public-api';
import { getErrors, isResponse } from 'public-api/utils';
import { useAsyncFunction } from 'stores/hooks';
import { Button, Form, Modal } from 'ui';

type Props = {
  remarketingSettingsId: UUIDField;
  ticket: BackendPublic.TicketDetail;
  open: boolean;
  onClose: () => void;
  onSuccess: (phoneNumber: string) => void;
};

function CallRequestModal({ remarketingSettingsId, ticket, open, onClose, onSuccess }: Props) {
  const publicApi = usePublicApi();

  const [phoneNumber, setPhoneNumber] = useState<string>('');
  const [error, setError] = useState<string>();

  const [handleSubmit, isSubmitting] = useAsyncFunction(async () => {
    try {
      const response = await publicApi.MarketplaceRemarketingCallRequestApi.create({
        settings_id: remarketingSettingsId,
        request: { ticket_id: ticket.id, phone_number: phoneNumber },
      });
      onSuccess(response.phone_number);
    } catch (e) {
      if (isResponse(e) && e.response.status === 400) {
        setError(await getErrors(e));
      }
    }
  });

  return (
    <Modal size="md" open={open} dismissible onClose={onClose}>
      <Modal.Content>
        <Form onSubmit={handleSubmit}>
          <Form.Input
            label={gettext('Fill in your phone number')}
            type="tel"
            name="phone"
            value={phoneNumber}
            onChange={setPhoneNumber}
            error={error?.phone_number}
          />
          <div className="mt-4 flex justify-between gap-2">
            <Button onClick={onClose}>{gettext('Close')}</Button>
            <Button loading={isSubmitting} primary submit icon="phone" iconSolid>
              {gettext('Call me')}
            </Button>
          </div>
        </Form>
      </Modal.Content>
    </Modal>
  );
}

export default CallRequestModal;
